import { render, staticRenderFns } from "./EditResidentModal.vue?vue&type=template&id=54bc023e&"
import script from "./EditResidentModal.vue?vue&type=script&lang=js&"
export * from "./EditResidentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54bc023e')) {
      api.createRecord('54bc023e', component.options)
    } else {
      api.reload('54bc023e', component.options)
    }
    module.hot.accept("./EditResidentModal.vue?vue&type=template&id=54bc023e&", function () {
      api.rerender('54bc023e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/condoMngt/component/EditResidentModal.vue"
export default component.exports